/* ============================================================================
   Ancona Pass 25 — shared-shortlist successor (ancona-shortlist-plus.js)  [A9]
   Successor to the frozen Pass 12 one-shot shortlist modal (its 'shortlist'
   token is removed from the innovation.js script tag in layout/theme.liquid —
   that file's designed revert path; the frozen file itself is untouched).
   Where the old viewer discarded the prices it had already fetched and
   evaporated on close, this renders a persistent, REOPENABLE strip for
   /?shortlist=h1,h2 links: validated handles (max 8, same rules as the old
   viewer), root-aware /products/{handle}.js fetches (I1), formatted prices
   from the fetched payloads (variant-min cents → money, "From …" when prices
   vary), truthful unavailable states ("Sold out" per piece; an aggregated
   note for handles the shop confirms 404), and an actions slot
   (.ancona-sl2__actions) that ancona-saved-cart.js fills with "Save these to
   my list" (B10). Closing collapses the strip to a reopen chip — nothing
   evaporates. Activates ONLY when location.search carries shortlist=.
   No PII, no cookies, no storage writes (importing into Saved is the
   saved-cart layer's job), no third-party code.
   Feature flag: this <script> tag's data-ancona-shortlist2 attribute (token:
   viewer). Absent attribute -> on; empty string -> off.
   Revert: remove the two data-ancona-shortlist2 lines in layout/theme.liquid
   + this file + assets/ancona-shortlist-plus.css (and restore the 'shortlist'
   token on the innovation.js tag to bring the old modal back).
   ============================================================================ */
(function () {
  'use strict';
  try {
    if (window.__anconaShortlistPlus) return;
    window.__anconaShortlistPlus = true;

    var script = document.currentScript;
    var featAttr = script ? script.getAttribute('data-ancona-shortlist2') : null;
    /* Absent attribute → on; explicit empty string → off (documented revert path). */
    var FEATURES = (featAttr == null ? 'viewer' : featAttr).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (FEATURES.indexOf('viewer') === -1) return;

    function track(ev, payload) {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: 'ancona:' + ev }, payload || {}));
        document.dispatchEvent(new CustomEvent('ancona:' + ev, { detail: payload || {} }));
      } catch (e) { /* analytics must never break shopping */ }
    }

    /* Locale/market-safe root (I1 — same pattern as ancona-cart-save.js). */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function rootUrl(path) { return root.replace(/\/$/, '') + '/' + String(path).replace(/^\//, ''); }

    /* Cents → money string in the shop's active currency. */
    function money(cents) {
      try {
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        var opts = { style: 'currency', currency: cur };
        if (Math.round(cents) % 100 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
        return new Intl.NumberFormat('en-US', opts).format(cents / 100);
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function initViewer() {
      var m = /[?&]shortlist=([^&#]+)/.exec(location.search);
      if (!m) return; /* activates only on shared-shortlist URLs */
      var raw;
      try { raw = decodeURIComponent(m[1]); } catch (e) { return; } /* malformed %-encoding must not break the page */
      var handles = raw.split(',').filter(function (h) { return /^[a-z0-9][a-z0-9-]{0,120}$/.test(h); }).slice(0, 8);
      if (!handles.length) return;

      Promise.all(handles.map(function (h) {
        return fetch(rootUrl('/products/' + h + '.js'), { headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            if (r.status === 404) return { gone: true };
            return r.ok ? r.json() : null; /* network/5xx: skip silently, never claim "gone" */
          })
          ['catch'](function () { return null; });
      })).then(function (results) {
        var ok = [];
        var goneCount = 0;
        results.forEach(function (p) {
          if (p && p.gone) { goneCount++; return; }
          if (p && p.handle) ok.push(p);
        });
        if (!ok.length) return; /* nothing shareable survived — stay silent like the old viewer */
        buildStrip(ok, goneCount);
      });
    }

    function buildStrip(products, goneCount) {
      /* Items in the shared Saved shape — handed to ancona-saved-cart.js via
         the ancona:shortlist2_open event for the "Save these to my list" action. */
      var items = products.map(function (p) {
        var img = (p.featured_image || '');
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        if (img) img += (img.indexOf('?') === -1 ? '?width=128' : '&width=128');
        var cents = (typeof p.price_min === 'number') ? p.price_min : p.price;
        var priceStr = (typeof cents === 'number') ? ((p.price_varies ? 'From ' : '') + money(cents)) : '';
        return {
          h: p.handle,
          u: rootUrl('/products/' + p.handle),
          t: String(p.title || p.handle).slice(0, 80),
          p: priceStr.slice(0, 24),
          i: img,
          available: p.available !== false
        };
      });

      var strip = document.createElement('aside');
      strip.className = 'ancona-sl2';
      strip.setAttribute('aria-label', 'Shared shortlist');

      var head = document.createElement('div');
      head.className = 'ancona-sl2__head';
      var title = document.createElement('p');
      title.className = 'ancona-sl2__title';
      title.textContent = 'Shared shortlist';
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'ancona-sl2__close';
      close.setAttribute('aria-label', 'Collapse shared shortlist');
      close.innerHTML = '&times;';
      head.appendChild(title); head.appendChild(close);
      strip.appendChild(head);

      var note = document.createElement('p');
      note.className = 'ancona-sl2__note';
      note.textContent = 'Pieces shared with you.';
      strip.appendChild(note);

      var ul = document.createElement('ul');
      ul.className = 'ancona-sl2__list';
      ul.setAttribute('role', 'list');
      items.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'ancona-sl2__item';
        var a = document.createElement('a');
        a.href = it.u;
        a.className = 'ancona-sl2__link';
        if (it.i) {
          var img = document.createElement('img');
          img.src = it.i; img.alt = ''; img.loading = 'lazy'; img.width = 56; img.height = 56;
          a.appendChild(img);
        }
        var meta = document.createElement('span');
        meta.className = 'ancona-sl2__meta';
        var t = document.createElement('span'); t.className = 'ancona-sl2__t'; t.textContent = it.t;
        meta.appendChild(t);
        if (it.p) { var pr = document.createElement('span'); pr.className = 'ancona-sl2__p'; pr.textContent = it.p; meta.appendChild(pr); }
        if (!it.available) { var so = document.createElement('span'); so.className = 'ancona-sl2__soldout'; so.textContent = 'Sold out'; meta.appendChild(so); }
        a.appendChild(meta);
        li.appendChild(a);
        ul.appendChild(li);
      });
      strip.appendChild(ul);

      if (goneCount) {
        var goneNote = document.createElement('p');
        goneNote.className = 'ancona-sl2__gone';
        goneNote.textContent = goneCount === 1
          ? 'One shared piece is no longer available.'
          : goneCount + ' shared pieces are no longer available.';
        strip.appendChild(goneNote);
      }

      /* Actions slot — filled by ancona-saved-cart.js ("Save these to my list"). */
      var actions = document.createElement('div');
      actions.className = 'ancona-sl2__actions';
      strip.appendChild(actions);

      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'ancona-sl2__chip';
      chip.textContent = 'Shared shortlist (' + items.length + ')';
      chip.setAttribute('aria-expanded', 'true');
      chip.hidden = true;

      function collapse() {
        strip.hidden = true;
        chip.hidden = false;
        chip.setAttribute('aria-expanded', 'false');
        chip.focus();
      }
      function reopen() {
        strip.hidden = false;
        chip.hidden = true;
        chip.setAttribute('aria-expanded', 'true');
        close.focus();
        announceOpen();
      }
      function announceOpen() {
        /* Re-announce so ancona-saved-cart.js can (idempotently) inject its
           import action even if it booted after the first render. */
        try { document.dispatchEvent(new CustomEvent('ancona:shortlist2_open', { detail: { items: items } })); } catch (e) {}
      }

      close.addEventListener('click', collapse);
      chip.addEventListener('click', reopen);
      /* Escape collapses the strip when focus is inside it (it is non-modal:
         no focus trap, the page behind stays fully usable). */
      strip.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); collapse(); }
      });

      document.body.appendChild(strip);
      document.body.appendChild(chip);
      track('shortlist_view', { count: items.length, unavailable: goneCount || 0 });
      announceOpen();
    }

    function boot() {
      try { initViewer(); } catch (e) { /* the strip must never break the page */ }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  } catch (e) { /* the shortlist successor must never break the page */ }
})();
